export const getIsUpgradeSourceEligible = upgradeSource => {
  return ['email-automated-sends', 'livemessages-routing', 'meetings-settings-namespace-row', 'calling-free-account-upgrade', 'tasks-start-queue-new'].includes(upgradeSource);
};